import { supabase } from "@/integrations/supabase/client";

export interface PDFConversionResult {
  success: boolean;
  text?: string;
  originalUrl?: string;
  error?: string;
}

export interface WordToPDFResult {
  success: boolean;
  pdfUrl?: string;
  originalUrl?: string;
  error?: string;
}

export const convertWordToPDF = async (fileUrl: string): Promise<WordToPDFResult> => {
  try {
    console.log('Converting Word to PDF:', fileUrl);

    // Call edge function which uses server-side CONVERTAPI_SECRET
    const { data, error } = await supabase.functions.invoke('convert-word-to-pdf', {
      body: {
        fileUrl: fileUrl,
        fileName: fileUrl.split('/').pop() || 'document.docx'
      }
    });

    if (error) {
      console.error('Edge function error:', error);
      throw new Error(error.message || 'Edge function failed');
    }

    if (!data?.success || !data?.pdfUrl) {
      throw new Error(data?.error || 'PDF conversion failed');
    }

    console.log('Word to PDF conversion successful:', data.pdfUrl);

    return {
      success: true,
      pdfUrl: data.pdfUrl,
      originalUrl: fileUrl
    };

  } catch (error) {
    console.error('Error converting Word to PDF:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to convert Word to PDF'
    };
  }
};

export const convertPDFToText = async (fileUrl: string): Promise<PDFConversionResult> => {
  try {
    console.log('Converting PDF to text:', fileUrl);

    // Call edge function which uses server-side CONVERTAPI_SECRET
    const { data, error } = await supabase.functions.invoke('convert-pdf-to-text', {
      body: {
        fileUrl: fileUrl
      }
    });

    if (error) {
      console.error('Edge function error:', error);
      throw new Error(error.message || 'Edge function failed');
    }

    if (!data?.success) {
      throw new Error(data?.error || 'PDF to text conversion failed');
    }

    return {
      success: true,
      text: data.text,
      originalUrl: fileUrl
    };

  } catch (error) {
    console.error('Error converting PDF to text:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to convert PDF'
    };
  }
};
